import MediaTabs from "./MediaTabs";

export default MediaTabs;